<template>
    <SideFormSection>
        <template #title> Custom fields </template>
        <template #subtitle>
            Add custom fields to this service to collect personalized
            information.
        </template>
        <template #rawContent>
            <Card
                title="Custom Fields"
                iconName="font"
            >
                <template #content>
                    <div class="space-y-4">
                        <Alert
                            v-if="serviceAggregate.service.isRecurring()"
                            title="NOTE:"
                            type="info"
                        >
                            For recurring meetings, the custom field responses
                            will only be attached to the first meeting.
                        </Alert>

                        <ServiceCustomFieldTable
                            :service="serviceAggregate.service"
                            :customFields="serviceAggregate.customFields"
                        />
                    </div>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import Card from '@/Shared/Component/Card.vue'
    import ServiceCustomFieldTable from '@/App/Service/Component/CustomField/ServiceCustomFieldTable.vue'
    import ServiceAggregate from '@/App/Service/Entity/ServiceAggregate'
    import Alert from '@/Shared/Component/Alert.vue'

    const props = defineProps({
        serviceAggregate: {
            type: Object as PropType<ServiceAggregate>,
            required: true,
        },
    })
</script>
